<template>
  <div
    :class="[
      'plan-skill-dive-learning-area-item',
      isPremiumPlusSelected && 'plan-skill-dive-learning-area-item__disabled',
    ]"
    @click="handleClick"
  >
    <div
      class="plan-skill-dive-learning-area-item__tooltip"
      v-if="isPremiumPlusSelected"
      v-tooltip="{
        content: premiumPlusTooltip,
        placement: 'top',
      }"
    ></div>
    <div
      :class="[
        'plan-skill-dive-learning-area-item__border',
        `plan-skill-dive-learning-area-item__border--${item.merchant_id}`,
      ]"
    >
      <div
        :class="[
          'plan-skill-dive-learning-area-item__background',
          asAddOns && 'plan-skill-dive-learning-area-item__background--as-add-ons',
        ]"
      >
        <div class="plan-skill-dive-learning-area-item__content">
          <img :src="icon" :alt="item.name" class="plan-skill-dive-learning-area-item__la-icon" />
          <div class="plan-skill-dive-learning-area-item__la-name">
            {{ item.label }}
          </div>
          <div
            :class="[
              'plan-skill-dive-learning-area-item__la-checkbox',
              asAddOns && 'plan-skill-dive-learning-area-item__la-checkbox--as-add-ons',
            ]"
          >
            <CheckBox
              :cartTheme="asAddOns"
              :isSelected="isSelected"
              :disabled="isPremiumPlusSelected"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import { updateCart, mixpanelEvent } from '@/helpers/mixins'
import CheckBox from '@/components/shared/CheckBox.vue'
import CyberSecurity from '@/assets/images/hero-section/skill-dive/learning-areas/cyber-security.png'
import Networking from '@/assets/images/hero-section/skill-dive/learning-areas/networking.png'
import Cloud from '@/assets/images/hero-section/skill-dive/learning-areas/cloud.png'

const {
  SKILL_DIVE_LEARNING_AREAS: { NETWORKING, CYBER_SECURITY, CLOUD },
  PLANS: { PREMIUM_PLUS },
} = CONSTANTS

export default {
  name: 'PlanSkillDiveLearningAreaItem',
  mixins: [updateCart, mixpanelEvent],
  props: {
    plan: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    asAddOns: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    CheckBox,
  },
  computed: {
    ...mapGetters({
      plans: 'products/plansByTerm',
      shoppingCart: 'shoppingCart/getShoppingCart',
    }),
    icon() {
      let badge = {}
      switch (this.item.merchant_id) {
        case NETWORKING:
          badge = Networking
          break
        case CYBER_SECURITY:
          badge = CyberSecurity
          break
        case CLOUD:
          badge = Cloud
          break
        default:
          break
      }
      return badge
    },
    isSelected() {
      return this.plan.addOnsOnCart.some(addOn => addOn.id === this.item.id)
    },
    isPremiumPlusSelected() {
      return !!this.shoppingCart.find(item => item.merchant_id === PREMIUM_PLUS)
    },
  },
  data() {
    return {
      premiumPlusTooltip:
        '<div style="width: 362px; text-align: center">Premium Plus includes one Skill Dive focus area. Add additional focus area(s) in the next step or remove Premium Plus to purchase Skill Dive separately.</div>',
    }
  },
  methods: {
    handleClick() {
      if (this.isPremiumPlusSelected) {
        return
      }
      const cartMerchantIds = this.shoppingCart.map(item => item.merchant_id)
      if (cartMerchantIds.includes(CONSTANTS.PLANS.SKILL_DIVE_ANNUAL)) {
        this.gaRemoveFromCartEvent(
          this.plan,
          Object.assign({}, this.$store, { rootState: this.fullState })
        )
      }
      if (!this.isSelected) {
        this.plan.addOnsOnCart.push(this.item)
        if (this.asAddOns) this.plan.selectedAsAddOns = true
      } else if (this.plan.addOnsOnCart.length > 1) {
        this.removeAddOnFromPlan(this.plan, this.item)
        if (this.asAddOns && this.plan.addOnsOnCart.length === 0) this.plan.selectedAsAddOns = false
      } else {
        this.removeAddOnFromPlan(this.plan, this.item)
      }
      if (this.plan.addOnsOnCart.length > 0) {
        this.removeProductFromCart(this.plan)
        this.updateSelectedPlan(this.plan)
      } else {
        this.removeProductFromCart(this.plan)
      }
    },
  },
  watch: {
    shoppingCart: {
      immediate: true,
      handler(items) {
        // if clearCart triggered
        if (items.length === 0) {
          this.plan.addOnsOnCart = []
          this.plan.selectedAsAddOns = false
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.tooltip {
  max-width: 364px !important;
  white-space: normal !important;
}
.plan-skill-dive-learning-area-item {
  position: relative;
  cursor: pointer;

  &__disabled {
    cursor: not-allowed;
  }
  &__tooltip {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  &__border {
    background: var(--mid-gray-gradient);
    padding: 1px;
    border-radius: 20px;
    transition: 1.2s all ease;
    height: fit-content;
    &--skill_dive_cyber {
      background: rgba(187, 133, 255, 1);
      background: linear-gradient(
        160deg,
        rgba(122, 123, 127, 0.7) 20%,
        rgba(62, 63, 73, 0) 75%,
        rgb(187, 133, 255, 1) 110%
      );
    }
    &--skill_dive_networking {
      background: rgba(250, 215, 64, 1);
      background: linear-gradient(
        160deg,
        rgba(122, 123, 127, 0.7) 20%,
        rgba(62, 63, 73, 0) 75%,
        rgb(250, 215, 64, 1) 110%
      );
    }
    &--skill_dive_cloud {
      background: rgba(136, 169, 255, 1);
      background: linear-gradient(
        160deg,
        rgba(122, 123, 127, 0.7) 20%,
        rgba(62, 63, 73, 0) 75%,
        rgb(136, 169, 255, 1) 110%
      );
    }
  }
  &__background {
    background: var(--mid-gray-gradient);
    border-radius: 20px;
    transition: 0.2 all ease-in;
    &:hover {
      background: var(--light-gray);
    }
    &--as-add-ons {
      background: var(--mid-gray-gradient-two);
    }
  }
  &__content {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    @include mobile {
      padding: 20px;
    }
  }
  &__la-icon {
    width: 36px;
    height: 36px;
  }
  &__la-name {
    white-space: nowrap;
  }
  &__la-checkbox {
    width: 100%;
    text-align: right;
    &--as-add-ons {
      height: 26px;
    }
  }
}
</style>
